import React, { useState } from "react";
import PageHeading from "../../components/PageHeading";
import * as Yup from "yup";
import { imageFormat, imageSize } from "../../utils/functions";
import { toast } from "react-hot-toast";
import paymentService from "../../services/paymentInfo";
import { useNavigate } from "react-router-dom";
import PaymentForm from "../../components/Forms/PaymentForm";

const initialValues = {
    img: "",
};
const validationSchema = Yup.object().shape({
    img: Yup.mixed()
        .test("image-format", "يرجى تحميل صورة", value => {
            return value
                ? imageFormat.includes(value.type.split("/")[1])
                : false;
        })
        .test("img-size", "حجم الصورة لايجب ان يتجاوز 5mb", value => {
            return value ? imageSize >= value.size : false;
        }),
});
const AddPayment = ({ title }) => {
    const [paymentAr, setPaymentAr] = useState("");
    const [paymentEn, setPaymentEn] = useState("");
    const navigate = useNavigate();

    const onSubmit = (values, { setSubmitting }) => {
        if (paymentAr !== "" && paymentEn !== "") {
            const formData = new FormData();
            formData.append("text_ar", paymentAr);
            formData.append("text_en", paymentEn);
            formData.append("img", values.img);
            paymentService
                .addPayment(formData)
                .then(res => {
                    toast.success("تم الاضافة بنجاح");
                    setTimeout(() => {
                        navigate("/payment-info", { replace: true });
                    }, 1500);
                })
                .catch(err => {
                    console.log(err);
                    toast.error("فشلت عملية الاضافة");
                    setSubmitting(false);
                });
        } else {
            setSubmitting(false);
            toast.error("بعض الحقول فارغة");
        }
    };
    return (
        <div>
            <PageHeading>{title}</PageHeading>

            <PaymentForm
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                paymentAr={paymentAr}
                paymentEn={paymentEn}
                setPaymentAr={setPaymentAr}
                setPaymentEn={setPaymentEn}
                btnText={"إضافة"}
            />
        </div>
    );
};

export default AddPayment;
